import { render, staticRenderFns } from "./table-devis-updated.vue?vue&type=template&id=6dca0773&scoped=true&"
import script from "./table-devis-updated.vue?vue&type=script&lang=js&"
export * from "./table-devis-updated.vue?vue&type=script&lang=js&"
import style0 from "./table-devis-updated.vue?vue&type=style&index=0&id=6dca0773&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca0773",
  null
  
)

export default component.exports